// import React from "react";
// import "./feedback.css";
// import pr2 from "../../img/Group 143.png";
// import pr3 from "../../img/3.png";
// import pr4 from "../../img/7.png";
// import pr5 from "../../img/5.png";
// import bl1 from "../../img/pr1.jpg";
// import bl2 from "../../img/pd1.jpg";
// import bl3 from "../../img/pd6.jpg";
// import vid from "../../img/Wikiworks_27 06 2024.mp4";
// // import pr4 from "../../img/wikiworks logo 230725-01 2.png";

// function feedback({ openModal }) {
//   return (
//     <div className="feedback-main">
//       <div className="vid-feeback-main">
//         {/* <img src={pr2} alt="" className="vid-feedback-img"></img> */}
//         {/* <iframe
//           src="https://drive.google.com/file/d/1Jwv1NFyNOkEm6LfvMJy0kDkm0iQhuVjb/view?usp=drive_link"
//           className="vid-feedback-img"
//           allow="autoplay"
//         ></iframe> */}
//         <video
//           autoPlay
//           muted
//           loop
//           controls
//           width="640"
//           height="480"
//           className="vid-feedback-img"
//           poster={pr2}
//         >
//           <source src={vid} type="video/mp4" />
//           Your browser does not support the video tag.
//         </video>
//         <div className="vid-feedback-content-main">
//           <div className="vid-feedback-content-header1">
//             Revolutionizing Compliance{" "}
//             <span className="vid-feedback-content-header-color">
//               - So You Can
//             </span>{" "}
//             Focus  <span className="line-break">on Growth!</span>
//           </div>

//           <div className="vid-feedback-content-sub-para">
//             Don’t let Compliance risks slow you down! See how we simplify
//             contract labor management—watch now and stay ahead!
//           </div>
//           <div className="vid-feedback-button-cont">
//             <button onClick={openModal} className="award-button-f">
//               Book Demo
//             </button>
//           </div>
//         </div>
//       </div>

     
//     </div>
//   );
// }

// export default feedback;
// import React from "react";
// import "./feedback.css";
// import pr2 from "../../img/Group 143.png";
// import pr3 from "../../img/3.png";
// import pr4 from "../../img/7.png";
// import pr5 from "../../img/5.png";
// import bl1 from "../../img/pr1.jpg";
// import bl2 from "../../img/pd1.jpg";
// import bl3 from "../../img/pd6.jpg";
// import vid from "../../img/Wikiworks_27 06 2024.mp4";
// import { useSpring, useTrail, animated } from "@react-spring/web";
// import { useInView } from "react-intersection-observer";

// function Feedback({ openModal }) {
//   // Detect when component is in view
//   const { ref, inView } = useInView({
//     triggerOnce: false, // Allow animations to replay if component leaves and re-enters viewport
//     threshold: 0.3, // Trigger when 30% of component is visible
//   });

//   // Animation for video (fade-in and slide-up)
//   const videoProps = useSpring({
//     opacity: inView ? 1 : 0,
//     transform: inView ? "translateY(0)" : "translateY(50px)",
//     config: { tension: 150, friction: 30 }, // Slower, smoother animation
//     delay: 200,
//   });

//   // Split header text into words for staggered animation
//   const headerText = "Revolutionizing Compliance - So You Can Focus on Growth!".split(" ");
//   const trail = useTrail(headerText.length, {
//     opacity: inView ? 1 : 0,
//     transform: inView ? "translateY(0)" : "translateY(20px)",
//     config: { mass: 1, tension: 1500, friction: 120 }, // Slower, smoother staggered effect
//     delay: 400,
//   });

//   // Animation for sub-paragraph (fade-in and slide-up)
//   const subParaProps = useSpring({
//     opacity: inView ? 1 : 0,
//     transform: inView ? "translateY(0)" : "translateY(20px)",
//     config: { tension: 150, friction: 30 }, // Slower, smoother animation
//     delay: 800,
//   });

//   // Animation for button (fade-in and scale)
//   const buttonProps = useSpring({
//     opacity: inView ? 1 : 0,
//     transform: inView ? "scale(1)" : "scale(0.8)",
//     config: { tension: 150, friction: 30 }, // Slower, smoother animation
//     delay: 1000,
//   });

//   return (
//     <div className="feedback-main" ref={ref}>
//       <div className="vid-feeback-main">
//          {/* <animated.img src={pr2} alt="" className="vid-feedback-img"></animated.img> */}
//         <animated.video
//           autoPlay
//           muted
//           loop
//           controls
//           width="640"
//           height="480"
//           className="vid-feedback-img"
//           poster={pr2}
//           style={videoProps}
//         >
//           <source src={vid} type="video/mp4" />
//           Your browser does not support the video tag.
//         </animated.video>
//         <div className="vid-feedback-content-main">
//           <div className="vid-feedback-content-header1">
//             {trail.map((props, index) => (
//               <animated.span key={index} style={props}>
//                 {headerText[index]}{" "}
//               </animated.span>
//             ))}
//           </div>

//           <animated.div className="vid-feedback-content-sub-para" style={subParaProps}>
//             Don’t let Compliance risks slow you down! See how we simplify
//             contract labor management—watch now and stay ahead!
//           </animated.div>
//           <div className="vid-feedback-button-cont">
//             <animated.button
//               onClick={openModal}
//               className="award-button-f"
//               style={buttonProps}
//             >
//               Book Demo
//             </animated.button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default Feedback;

import React from "react";
import "./feedback.css";
import pr2 from "../../img/Group 143.png";
import vid from "../../img/Wikiworks_27 06 2024.mp4";
import { useSpring, animated } from "@react-spring/web";
import { useInView } from "react-intersection-observer";

function Feedback({ openModal }) {
  // Detect when component is in view
  const { ref, inView } = useInView({
    triggerOnce: false, // Allow animations to replay if component leaves and re-enters viewport
    threshold: 0.3, // Trigger when 30% of component is visible
  });

  // Animation for video (fade-in and slide-up, unchanged)
  const videoProps = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? "translateY(0)" : "translateY(50px)",
    config: { tension: 150, friction: 30 },
    delay: 200,
  });

  // Animation for the entire right-side content (fade-in and slide-up)
  const contentProps = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? "translateY(0)" : "translateY(20px)",
    config: { tension: 150, friction: 30 },
    delay: 400,
  });

  return (
    <div className="feedback-main" ref={ref}>
      <div className="vid-feeback-main">
        <animated.video
          autoPlay
          muted
          loop
          controls
          width="640"
          height="480"
          className="vid-feedback-img"
          poster={pr2}
          style={videoProps}
        >
          <source src={vid} type="video/mp4" />
          Your browser does not support the video tag.
        </animated.video>
        <animated.div className="vid-feedback-content-main" style={contentProps}>
          <div className="vid-feedback-content-header1">
            Revolutionizing Compliance - So You Can Focus on Growth!
          </div>
          <div className="vid-feedback-content-sub-para">
            Don’t let Compliance risks slow you down! See how we simplify
            contract labor management—watch now and stay ahead!
          </div>
          <div className="vid-feedback-button-cont">
            <button onClick={openModal} className="award-button-f">
              Book Demo
            </button>
          </div>
        </animated.div>
      </div>
    </div>
  );
}

export default Feedback;